var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';
import { Column, Scrolling, Sorting } from 'devextreme-react/data-grid';
import { FaDownload } from 'react-icons/fa';
import ErrorBoundary from '@app/Components/ErrorBoundary/ErrorBoundary';
import { PageTitle } from '@app/Components/PageTitle/PageTitle';
import { Widget } from '@app/Components/Widget/Widget';
import { Grid } from '@app/Components/Grid/Grid';
import { Button } from '@app/Components/Button/Button';
import { DownloadButton } from '@app/Components/DownloadButton/DownloadButton';
import { Link } from '@app/Components/Link/Link';
import { DateBox } from '@app/Widgets/DateBox/DateBox';
import { Api } from '@app/Api';
import DownloadService from '@app/Services/DownloadService';
import { signalRService } from '@app/Services/SignalRService';
import { SignalREvents } from '@app/AppConstants';
import { DocumentsDownloadFilter } from './DocumentsDownloadFilter/DocumentsDownloadFilter';
import { DocumentsDownloadProgressModal } from './DocumentsDownloadProgressModal/DocumentsDownloadProgressModal';
import styles from './DocumentsDownload.module.scss';
var gridName = 'DocumentsDownloadGrid';
export var DocumentsDownload = /** @class */ (function (_super) {
    __extends(DocumentsDownload, _super);
    function DocumentsDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._filters = null;
        _this._documents = [];
        _this._loading = false;
        _this._isDownloading = false;
        _this._isDownloadFailed = false;
        _this._isProgressModalOpen = false;
        _this._archiveProgress = null;
        _this._currentFilterParams = undefined;
        _this._lastFilterParamsRequest = '';
        _this._downloadOperationId = '';
        return _this;
    }
    Object.defineProperty(DocumentsDownload.prototype, "_documentsCount", {
        get: function () {
            return this._documents.length;
        },
        enumerable: false,
        configurable: true
    });
    DocumentsDownload.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filters;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        signalRService.subscribe(SignalREvents.deliverableDocumentsArchiveProgress, this._handleArchiveProgress);
                        return [4 /*yield*/, Api.secured.getPrincipalFilterConfiguration({ name: gridName })];
                    case 1:
                        filters = _a.sent();
                        this._setFilters(filters || {});
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.deliverableDocumentsArchiveProgress, this._handleArchiveProgress);
    };
    DocumentsDownload.prototype._setFilters = function (filters) {
        this._filters = filters;
    };
    DocumentsDownload.prototype._saveFilters = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.addOrUpdatePrincipalFilterConfiguration({
                            name: gridName,
                            filterModel: filters ? JSON.stringify(filters) : ''
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.deletePrincipalFilterConfiguration({ name: gridName })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._loadDocuments()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._clearFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDocuments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._filterProjects = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDocuments(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._loadDocuments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var filterParamsRequest, documents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this._loading = true;
                        this._currentFilterParams = params;
                        filterParamsRequest = JSON.stringify(params);
                        this._lastFilterParamsRequest = filterParamsRequest;
                        return [4 /*yield*/, Api.secured.getProjectDeliverableDocuments(__assign({}, params))];
                    case 1:
                        documents = _a.sent();
                        if (this._lastFilterParamsRequest === filterParamsRequest) {
                            this._setDocuments(documents);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._setDocuments = function (documents) {
        this._documents = documents;
    };
    DocumentsDownload.prototype._handleArchiveProgress = function (eventName, progress) {
        // The same user can archive documents from another tab as well - progress of those
        // downloads arrives here too and does not belong to the dialog of this page.
        if (progress.operationId !== this._downloadOperationId)
            return;
        this._archiveProgress = progress;
    };
    DocumentsDownload.prototype._toggleProgressModal = function () {
        this._isProgressModalOpen = !this._isProgressModalOpen;
    };
    DocumentsDownload.prototype._handleDownloadAllClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var operationId, response, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        operationId = "".concat(Date.now(), "-").concat(Math.random()
                            .toString(36)
                            .substring(2));
                        this._downloadOperationId = operationId;
                        this._isDownloading = true;
                        this._isDownloadFailed = false;
                        this._archiveProgress = null;
                        this._isProgressModalOpen = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, Api.secured.downloadProjectDeliverableDocuments(__assign(__assign({}, this._currentFilterParams), { operationId: operationId }))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.blobBody];
                    case 3:
                        data = _a.sent();
                        DownloadService.downloadByData(data, 'Documents.zip');
                        this._setDownloadFinished(false);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this._setDownloadFinished(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownload.prototype._setDownloadFinished = function (isFailed) {
        this._isDownloading = false;
        this._isDownloadFailed = isFailed;
    };
    DocumentsDownload.prototype.render = function () {
        return (React.createElement(ErrorBoundary, null,
            React.createElement(PageTitle, { title: "Documents Download" }),
            this._filters && (React.createElement(DocumentsDownloadFilter, { defaultFilters: this._filters, onFiltersSave: this._saveFilters, onFilterReset: this._resetFilters, onFilterClear: this._clearFilters, onFilterProjects: this._filterProjects })),
            React.createElement("div", { className: styles.actions },
                React.createElement(Button, { className: styles.downloadButton, color: "primary", onClick: this._handleDownloadAllClick, disabled: !this._documentsCount || this._loading || this._isDownloading },
                    React.createElement(FaDownload, { title: "Download all documents" }),
                    "Download All")),
            React.createElement(DocumentsDownloadProgressModal, { isOpen: this._isProgressModalOpen, isDownloadFinished: !this._isDownloading, isDownloadFailed: this._isDownloadFailed, progress: this._archiveProgress, toggle: this._toggleProgressModal }),
            React.createElement(Widget, { title: React.createElement("div", { className: styles.title },
                    React.createElement("div", null, "Documents"),
                    React.createElement("div", null,
                        "Count: ",
                        this._documentsCount)) },
                React.createElement(Grid, { dataSource: this._documents, loading: this._loading, style: { maxHeight: '60vh' } },
                    React.createElement(Scrolling, { mode: "infinite" }),
                    React.createElement(Sorting, { mode: "multiple" }),
                    React.createElement(Column, { caption: "Project", dataField: "projectCodeName", width: 140, cellRender: function (_a) {
                            var data = _a.data;
                            return (React.createElement(Link, { to: "/projects/".concat(data.projectCodeName) }, data.projectCodeName));
                        } }),
                    React.createElement(Column, { caption: "Project Name", dataField: "projectDisplayName", minWidth: 200 }),
                    React.createElement(Column, { caption: "Gate", dataField: "gateDisplayName", width: 100 }),
                    React.createElement(Column, { caption: "Deliverable Code", dataField: "deliverableCode", width: 140 }),
                    React.createElement(Column, { caption: "Deliverable", dataField: "deliverableName", minWidth: 200 }),
                    React.createElement(Column, { caption: "File", dataField: "originalFileName", minWidth: 200 }),
                    React.createElement(Column, { caption: "Version", dataField: "version", width: 80 }),
                    React.createElement(Column, { caption: "Uploaded", dataField: "uploadedDate", dataType: "date", width: 120, defaultSortOrder: "desc", cellRender: function (_a) {
                            var data = _a.data;
                            return (React.createElement(DateBox, { date: data.uploadedDate }));
                        } }),
                    React.createElement(Column, { caption: "Uploaded By", dataField: "uploadedBy", width: 180 }),
                    React.createElement(Column, { caption: "Download", width: 90, alignment: "center", allowFiltering: false, allowSorting: false, cellRender: function (_a) {
                            var data = _a.data;
                            return (React.createElement(DownloadButton, { fileId: data.fileId }));
                        } })))));
    };
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_filters", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_documents", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_loading", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_isDownloading", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_isDownloadFailed", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_isProgressModalOpen", void 0);
    __decorate([
        observable
    ], DocumentsDownload.prototype, "_archiveProgress", void 0);
    __decorate([
        computed
    ], DocumentsDownload.prototype, "_documentsCount", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_setFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_saveFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_resetFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_clearFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_filterProjects", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_loadDocuments", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_setDocuments", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_handleArchiveProgress", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_toggleProgressModal", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_handleDownloadAllClick", null);
    __decorate([
        action.bound
    ], DocumentsDownload.prototype, "_setDownloadFinished", null);
    DocumentsDownload = __decorate([
        observer
    ], DocumentsDownload);
    return DocumentsDownload;
}(React.PureComponent));
